import axios from "../../plugins/axios";

export const errorLogsStore = {
    namespaced: true,
    state: () => ({
        errorLogs: [],
        stats: null,
        loading: false,
        pagination: {
            current_page: 1,
            last_page: 1,
            per_page: 50,
            total: 0
        },
        filters: {
            level: null,
            method: null,
            error_type: null,
            date_from: null,
            date_to: null,
            stuck_only: false
        }
    }),
    mutations: {
        setErrorLogs(state, payload) {
            console.log('[ErrorLogs Mutation] setErrorLogs chamado com:', payload);
            console.log('[ErrorLogs Mutation] payload.data:', payload?.data);
            console.log('[ErrorLogs Mutation] payload.pagination:', payload?.pagination);
            
            // Garantir que sempre temos um array
            if (payload && payload.data) {
                state.errorLogs = Array.isArray(payload.data) ? payload.data : [];
                console.log('[ErrorLogs Mutation] errorLogs definido como array com', state.errorLogs.length, 'itens');
            } else {
                state.errorLogs = [];
                console.log('[ErrorLogs Mutation] errorLogs definido como array vazio (payload.data não existe)');
            }
            if (payload && payload.pagination) {
                state.pagination = {
                    current_page: payload.pagination.current_page || 1,
                    last_page: payload.pagination.last_page || 1,
                    per_page: payload.pagination.per_page || 50,
                    total: payload.pagination.total || 0
                };
                console.log('[ErrorLogs Mutation] pagination atualizado:', state.pagination);
            }
            console.log('[ErrorLogs Mutation] Estado final:', { errorLogs: state.errorLogs, pagination: state.pagination });
        },
        setStats(state, payload) {
            state.stats = payload;
        },
        setLoading(state, payload) {
            state.loading = payload;
        },
        setFilters(state, payload) {
            state.filters = { ...state.filters, ...payload };
        }
    },
    actions: {
        GET_ERROR_LOGS({ commit, state }) {
            console.log('[ErrorLogs Action] GET_ERROR_LOGS chamado');
            console.log('[ErrorLogs Action] Estado atual:', { pagination: state.pagination, filters: state.filters });
            console.log('[ErrorLogs Action] state:', state);
            console.log('[ErrorLogs Action] commit:', typeof commit);
            
            commit('setLoading', true);
            
            return new Promise((resolve, reject) => {
                try {
                    console.log('[ErrorLogs Action] Dentro do Promise');
                    // Padrão: dia atual no fuso do usuário (igual ao filtro "Hoje")
                    const today = new Date();
                    const formatLocal = (d) => {
                        const y = d.getFullYear();
                        const m = String(d.getMonth() + 1).padStart(2, '0');
                        const day = String(d.getDate()).padStart(2, '0');
                        return `${y}-${m}-${day}`;
                    };
                    const defaultFrom = state.filters.date_from || formatLocal(today);
                    const defaultTo = state.filters.date_to || formatLocal(today);

                    const params = {
                        page: state.pagination.current_page,
                        per_page: state.pagination.per_page,
                        date_from: defaultFrom,
                        date_to: defaultTo,
                        ...state.filters
                    };

                    // Remove apenas valores vazios (mantém date_from/date_to)
                    Object.keys(params).forEach(key => {
                        if (params[key] === null || params[key] === undefined || params[key] === '') {
                            delete params[key];
                        }
                    });

                    console.log('[ErrorLogs] Fazendo requisição para error-logs', { 
                        params, 
                        token: localStorage.access_token ? 'presente' : 'ausente',
                        baseURL: axios.defaults.baseURL
                    });
                    
                    const requestConfig = {
                        params,
                        headers: {
                            "Authorization": localStorage.access_token,
                        }
                    };
                    
                    console.log('[ErrorLogs] Config da requisição:', requestConfig);
                    
                    // O baseURL já inclui /api, então não precisa adicionar novamente
                    axios.get('error-logs', requestConfig)
                        .then(response => {
                            console.log('[ErrorLogs] Resposta completa:', response);
                            console.log('[ErrorLogs] Response.data:', response.data);
                            console.log('[ErrorLogs] Response.data.data:', response.data?.data);
                            console.log('[ErrorLogs] Response.data.pagination:', response.data?.pagination);
                            
                            // Verificar se a resposta tem a estrutura esperada
                            if (response && response.data) {
                                // A API retorna { data: [...], pagination: {...} }
                                const responseData = response.data;
                                
                                // Garantir que temos data e pagination
                                if (responseData.data !== undefined && responseData.pagination !== undefined) {
                                    commit('setErrorLogs', {
                                        data: Array.isArray(responseData.data) ? responseData.data : [],
                                        pagination: responseData.pagination || state.pagination
                                    });
                                } else {
                                    // Se a estrutura for diferente, tentar adaptar
                                    console.warn('[ErrorLogs] Estrutura de resposta inesperada:', responseData);
                                    commit('setErrorLogs', {
                                        data: Array.isArray(responseData) ? responseData : [],
                                        pagination: state.pagination
                                    });
                                }
                            } else {
                                console.warn('[ErrorLogs] Response.data está vazio ou indefinido!');
                                commit('setErrorLogs', { data: [], pagination: state.pagination });
                            }
                            
                            commit('setLoading', false);
                            resolve(response);
                        })
                        .catch(error => {
                            console.error('[ErrorLogs] Erro na requisição:', error);
                            console.error('[ErrorLogs] Status:', error.response?.status);
                            console.error('[ErrorLogs] Detalhes do erro:', error.response?.data || error.message);
                            console.error('[ErrorLogs] Erro completo:', JSON.stringify(error, null, 2));
                            commit('setErrorLogs', { data: [], pagination: state.pagination });
                            commit('setLoading', false);
                            reject(error);
                        });
                } catch (err) {
                    console.error('[ErrorLogs] Erro ao preparar requisição:', err);
                    commit('setErrorLogs', { data: [], pagination: state.pagination });
                    commit('setLoading', false);
                    reject(err);
                }
            });
        },
        GET_ERROR_LOGS_STATS({ commit }, filters = {}) {
            return new Promise((resolve, reject) => {
                axios.get('error-logs/stats', { 
                    params: filters,
                    headers: {
                        "Authorization": localStorage.access_token,
                    }
                })
                    .then(response => {
                        commit('setStats', response.data.data);
                        resolve(response);
                    })
                    .catch(error => reject(error));
            });
        },
        SET_FILTERS({ commit }, filters) {
            commit('setFilters', filters);
        },
        SET_PAGE({ commit, state }, page) {
            commit('setErrorLogs', {
                data: state.errorLogs,
                pagination: { ...state.pagination, current_page: page }
            });
        }
    },
    getters: {
        errorLogs: state => {
            console.log('[ErrorLogs Getter] errorLogs chamado, state:', state);
            console.log('[ErrorLogs Getter] state.errorLogs:', state.errorLogs);
            return state.errorLogs || [];
        },
        stats: state => state.stats,
        loading: state => state.loading,
        pagination: state => state.pagination,
        filters: state => state.filters
    }
}

export default errorLogsStore;

